import { render } from "./UsaPort.vue?vue&type=template&id=677fb406&scoped=true"
import script from "./UsaPort.vue?vue&type=script&lang=js"
export * from "./UsaPort.vue?vue&type=script&lang=js"

import "./UsaPort.vue?vue&type=style&index=0&id=677fb406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677fb406"]])

export default __exports__